import AwDnd from '../components/DragAndDrop/AwDnd'
import cloneDeep from 'lodash/cloneDeep'

export default {
  emits: ['placePlaceholder', 'placeElement'],
  refs: [
    'dragHandle' // element which represent drag handle
  ],
  data() {
    return {
      dragged: false,
    }
  },
  methods: {
    // check if element can be dropped here
    canDropItem(item) {
      return !this.$options?.allowedChildElements ||
        this.$options?.allowedChildElements.includes(item.type)
    },
    createPlaceholder(item) {
      return this.setPlaceholderRecursive({ ...cloneDeep(item), key: 'placeholder' })
    },
    drop({ item, index }) {
      let parentChange = false
      // check rank if only rank change and parent does not change
      if ((item.parent__bc_document_data_rev_id === this.element.id || (this.element.type === 'document' && item.parent__bc_document_data_rev_id === null))) {
        // because old element has to be in dom because dragend event
        if (item.rank < index) {
          index--
        }
        // its possible that rank does not change, then do not trigger update
        if (item.rank === index) {
          return
        }
      } else {
        parentChange = true
      }

      this.bcDocumentStore.moveElementInDocument({
        ...this.unsetPlaceholderRecursive(item),
        updated: true,
        dragged: false,
      }, this.element, index)

      if (parentChange) {
        this.bcSelectedStore.reload()
      }

    },
    setPlaceholderRecursive(el) {
      el.placeholder = true
      el?.children?.forEach((child) => this.setPlaceholderRecursive(child))
      return el
    },
    unsetPlaceholderRecursive(el) {
      delete el.placeholder
      el?.children?.forEach((child) => this.unsetPlaceholderRecursive(child))
      return el
    }
  },
  computed: {
    children() {
      return this.element.children
    },
    draggedElement() {
      return AwDnd.draggedItem.value
    },
  },
}
